import {
    REQUEST_STATE,

    CORE_GET_ALL_PROJECT_REQUEST,
    CORE_GET_ALL_PROJECT_SUCCESS,
    CORE_GET_ALL_PROJECT_FAILURE,

    CORE_GET_PROJECT_REQUEST,
    CORE_GET_PROJECT_SUCCESS,
    CORE_GET_PROJECT_FAILURE,

} from '../types'

const requestState = REQUEST_STATE

export default {
    allProject: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_ALL_PROJECT_REQUEST:
                return state
            case CORE_GET_ALL_PROJECT_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload
                    if (result && datas) {
                        return datas
                    } else return []
                } else {
                    return []
                }
            case CORE_GET_ALL_PROJECT_FAILURE:
                return []
            default:
                return state
        }
    },
    project: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_PROJECT_REQUEST:
                return state
            case CORE_GET_PROJECT_SUCCESS:
                if (action.payload) {
                    const { result, datas, data } = action.payload
                    if (result && datas) {
                        return datas
                    } else if (result && data) {
                        return data
                    }
                    else return {}
                } else {
                    return {}
                }
            case CORE_GET_PROJECT_FAILURE:
                return {}
            default:
                return state
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/projectManagement.js